const LOGO_FALLBACK = '/logo.png';

const VARIANT_STYLES = {
  header: {
    frameClassName: 'shrink-0',
    imageClassName: 'h-12 md:h-16 drop-shadow-[0_8px_20px_rgba(30,79,161,0.14)]',
    paddingClassName: '',
  },
  footer: {
    frameClassName: 'shrink-0',
    imageClassName: 'h-14 md:h-20 drop-shadow-[0_14px_28px_rgba(15,23,42,0.28)]',
    paddingClassName: '',
  },
  admin: {
    frameClassName: 'shrink-0',
    imageClassName: 'h-9 md:h-10 drop-shadow-[0_6px_18px_rgba(30,79,161,0.12)]',
    paddingClassName: '',
  },
  section: {
    frameClassName: 'w-full',
    imageClassName: 'h-auto w-full max-w-full drop-shadow-[0_18px_36px_rgba(30,79,161,0.12)]',
    paddingClassName: '',
  },
};

export default function BrandLogo({
  src,
  alt,
  variant = 'header',
  frameClassName = '',
  imageClassName = '',
}) {
  const styles = VARIANT_STYLES[variant] || VARIANT_STYLES.header;

  return (
    <div
      className={`inline-flex items-center justify-center overflow-hidden ${styles.frameClassName} ${styles.paddingClassName} ${frameClassName}`.trim()}
    >
      <img
        src={src || LOGO_FALLBACK}
        alt={alt}
        className={`w-auto max-w-full object-contain object-center select-none ${styles.imageClassName} ${imageClassName}`.trim()}
        fetchPriority={variant === 'header' ? 'high' : undefined}
        loading={variant === 'header' ? undefined : 'lazy'}
        decoding="async"
        draggable="false"
        onError={(e) => { e.currentTarget.src = LOGO_FALLBACK; }}
      />
    </div>
  );
}
